import { request } from '@umijs/max';

export interface HjrxAdminLoginParams {
  username: string;
  password: string;
}

export interface HjrxAdminUser {
  id?: string;
  username?: string;
  name?: string;
  display_name?: string;
  avatar?: string;
  role?: string;
  access?: string;
}

export interface HjrxAdminLoginResult {
  token?: string;
  user?: HjrxAdminUser;
  status?: string;
  message?: string;
}

export async function adminLogin(data: HjrxAdminLoginParams) {
  return request<HjrxAdminLoginResult>('/api/admin/auth/login', {
    method: 'POST',
    data,
  });
}

export async function adminCurrentUser(options?: Record<string, any>) {
  return request<HjrxAdminUser>('/api/admin/auth/currentUser', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function adminLogout(options?: Record<string, any>) {
  return request<{ success?: boolean; message?: string }>(
    '/api/admin/auth/logout',
    {
      method: 'POST',
      ...(options || {}),
    },
  );
}
